import { createListenerMiddleware, type Dispatch, type ListenerEffectAPI, type PayloadAction } from '@reduxjs/toolkit'

import type { IdTokenData } from '@/features/auth/types/idTokenSchema'
import { appActions } from '../slices/appSlice'
import { userActions } from '../slices/userSlice'

const userDataMiddleware = createListenerMiddleware()

const effect = (action: PayloadAction<IdTokenData>, listenerApi: ListenerEffectAPI<unknown, Dispatch>) => {
  const userId = action.payload.sub

  if (userId) {
    const settingsJson = localStorage.getItem(`user-${userId}`)

    if (settingsJson) {
      try {
        const { isUtc, isDarkMode, isEnglish } = JSON.parse(settingsJson)

        listenerApi.dispatch(appActions.setUtc(isUtc))
        listenerApi.dispatch(appActions.setDarkMode(isDarkMode))
        listenerApi.dispatch(appActions.setEnglish(isEnglish))
      } catch (error) {
        console.error('Failed to parse settings from localStorage', error)
      }
    }
  }
}

userDataMiddleware.startListening({ actionCreator: userActions.setData, effect })

export default userDataMiddleware
